<template>
  <div>
    <div>
      <div class="row">
        <div class="col-md-11">
          <label>{{ $t("enseignant.listeNiveaux") }} : </label>
          <a-select
            :default-value="defaultLevelForSchoolType"
            @change="handleLevelChange"
            class="pb-2 pt-2 ml-3"
            style="width: 300px"
          >
            <a-select-option
              v-for="(value, name, index) in levelSelectData"
              :key="index"
              :value="name"
            >
              {{ value }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <template v-if="!loadingData">
        <div v-for="type in types" :key="type.name">
          <div class="card card-body mt-1 mb-2">
            <h5 style="color: blue" class="mb-2">
              {{ $t(type.translation) }}
            </h5>
            <div v-if="verifyPackAccess(type, 'v')">
              <div class="row mb-1">
                <div class="col-4">
                  <label class="mr-2"
                    >{{ $t("bulletin.coefTrimester1") }} :
                  </label>
                  <a-input-number v-model="type.targetData.trimester1" />
                </div>

                <div class="col-4">
                  <label class="mr-2"
                    >{{ $t("bulletin.coefTrimester2") }} :
                  </label>
                  <a-input-number v-model="type.targetData.trimester2" />
                </div>

                <div class="col-4">
                  <label class="mr-2"
                    >{{ $t("bulletin.coefTrimester3") }} :
                  </label>
                  <a-input-number v-model="type.targetData.trimester3" />
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-12 mt-2">
                  <label class="mr-2"
                    >{{ $t("bulletin.moyenneGeneral") }} :
                  </label>
                  <a-tag style="font-size: 18px" color="blue">
                    ( {{ $t("actualite.trimestre1") }} *
                    {{ type.targetData.trimester1 }} +
                    {{ $t("actualite.trimestre2") }} *
                    {{ type.targetData.trimester2 }} +
                    {{ $t("actualite.trimestre3") }} *
                    {{ type.targetData.trimester3 }} ) /
                    {{
                      type.targetData.trimester1 +
                      type.targetData.trimester2 +
                      type.targetData.trimester3
                    }}
                  </a-tag>
                </div>
              </div>
            </div>
            <a-skeleton v-else />
          </div>
        </div>
      </template>
      <template v-else>
        <a-skeleton />
      </template>

      <a-divider></a-divider>
      <div class="mt-4">
        <a-button
          :type="checkSaved || loadingData || loadingSave ? '' : 'primary'"
          :loading="loadingSave"
          :disabled="checkSaved || loadingData || loadingSave || isReadOnly"
          @click="
            () => {
              saveChange();
            }
          "
          icon="save"
        >
          {{ $t("all.save") }}
        </a-button>
        <a-button
          class="ml-2"
          :loading="loadingSave"
          :disabled="loadingData || loadingSave || checkSaved || isReadOnly"
          @click="handleReset"
          icon="undo"
        >
          {{ $t("action.reset") }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapGetters } from "vuex";
import { getLevels, getDefaultLevel } from "@/config/LevelConstants";

export default {
  name: "classrooms",

  beforeMount() {
    this.form = this.$form.createForm(this, { name: "SubjectForm" });
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["packDetailsGetter"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
    isReadOnly() {
      const value = this.packDetailsGetter?.access?.edManager?.bulletinCoef;
    return value === "ro";
    },
    checkSaved() {
      return this.savedTypes === JSON.stringify(this.types);
    },
    defaultLevelForSchoolType() {
      return getDefaultLevel(this.schoolType, this.countryCode);
    },
  },
  async created() {
 this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Paramètre de coefficient",
    });
    this.schoolType = this.activeBuilding.type;

    this.loadingData = true;

    this.schoolDetails = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0];

    apiClient
      .post("/bulletinCoef/filter", {
        query: {
          level: this.selectedLevel,
        },
      })
      .then((res) => {
        if (res.data) {
          const pedagogic = res.data.find((el) => el.type == "pedagogic");
          const specific = res.data.find((el) => el.type == "specific");

          const verySpecific = res.data.find((el) => el.type == "verySpecific");

          if (pedagogic) this.types[0].targetData = pedagogic;
          else
            this.types[0].targetData = {
              ...JSON.parse(JSON.stringify(this.defaultTargetData)),
            };

          if (specific) this.types[1].targetData = specific;
          else
            this.types[1].targetData = {
              ...JSON.parse(JSON.stringify(this.defaultTargetData)),
            };

          if (verySpecific) this.types[2].targetData = verySpecific;
          else
            this.types[2].targetData = {
              ...JSON.parse(JSON.stringify(this.defaultTargetData)),
            };

          this.savedTypes = JSON.stringify(this.types);
        }
      })
      .catch((e) => {
        this.$message.error(this.$t("error.erreur"));
      })
      .finally(() => {
        this.loadingData = false;
      });
  },
  data() {
    return {
      schoolType: null,
      schoolDetails: {},
      loadingSave: false,
      form: this.$form.createForm(this),
      data: null,
      savedTypes: "",
      loadingData: false,
      targetKeys: [],
      selectedLevel: "1",
      types: [
        {
          name: "pedagogic",
          translation: "bulletin.bulletinPedagogique",
          targetData: {
            trimester1: 1,
            trimester2: 1.5,
            trimester3: 2,
          },
        },
        {
          name: "specific",
          translation: "bulletin.bulletinSpecifique",
          targetData: {
            trimester1: 1,
            trimester2: 1.5,
            trimester3: 2,
          },
        },
        {
          name: "verySpecific",
          translation: "bulletin.bulletinVerySpecifique",
          targetData: {
            trimester1: 1,
            trimester2: 1.5,
            trimester3: 2,
          },
        },
      ],
      defaultTargetData: {
        trimester1: 1,
        trimester2: 1.5,
        trimester3: 2,
      },
    };
  },
  methods: {
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    verifyPackAccess: function ({ name }, type) {
      /*
            "bulletin": "v",//pedagogic
      "bulletinSpecific":"d",//verySpecific
      "bulletinPilote":"v",//specific
       */
      let accesName;
      switch (name) {
        case "pedagogic":
          accesName = "bulletin";
          break;
        case "verySpecific":
          accesName = "bulletinSpecific";
          break;
        case "specific":
          accesName = "bulletinPilote";
          break;
      }
      return this.packDetailsGetter.access.edManager[accesName] == type;
    },
    async saveChange() {
      this.loadingSave = true;

      const savedTypes = JSON.parse(this.savedTypes);

      for (const i in this.types) {
        const target = this.types[i].targetData;

        if (
          JSON.stringify(savedTypes[i].targetData) ==
          JSON.stringify(this.types[i].targetData)
        )
          continue;

        if (target._id) {
          await apiClient
            .patch("/bulletinCoef/" + target._id, {
              data: {
                trimester1: target.trimester1,
                trimester2: target.trimester2,
                trimester3: target.trimester3,
              },
            })
            .then((res) => {
              this.$message.success(this.$t("bulletin.coefBulletinsSaved"));
              this.savedTypes = JSON.stringify(this.types);
            })
            .catch((e) => {
              this.handleApiError(e, this.$t("error.erreur"));
            });
        } else {
          await apiClient
            .put("/bulletinCoef/", {
              data: {
                level: this.selectedLevel,
                type: this.types[i].name,
                trimester1: target.trimester1,
                trimester2: target.trimester2,
                trimester3: target.trimester3,
              },
            })
            .then((res) => {
              if (res.data) {
                this.types[i].targetData = res.data;
              }
              this.$message.success(this.$t("bulletin.coefBulletinsSaved"));
              this.savedTypes = JSON.stringify(this.types);
            })
            .catch((e) => {
              this.handleApiError(e, this.$t("error.erreur"));
            });
        }
      }


      this.loadingSave = false;
    },
    handleLevelChange(val) {
      this.selectedLevel = val;
      this.loadingData = true;
      apiClient
        .post("/bulletinCoef/filter", {
          query: {
            level: this.selectedLevel,
          },
        })
        .then((res) => {
          if (res.data) {
            const pedagogic = res.data.find((el) => el.type == "pedagogic");
            const specific = res.data.find((el) => el.type == "specific");

            const verySpecific = res.data.find(
              (el) => el.type == "verySpecific"
            );

            if (pedagogic) this.types[0].targetData = pedagogic;
            else
              this.types[0].targetData = {
                ...JSON.parse(JSON.stringify(this.defaultTargetData)),
              };

            if (specific) this.types[1].targetData = specific;
            else
              this.types[1].targetData = {
                ...JSON.parse(JSON.stringify(this.defaultTargetData)),
              };

            if (verySpecific) this.types[2].targetData = verySpecific;
            else
              this.types[2].targetData = {
                ...JSON.parse(JSON.stringify(this.defaultTargetData)),
              };

            this.savedTypes = JSON.stringify(this.types);
          }
        })
        .catch((e) => {
          this.$message.error(this.$t("error.erreur"));
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    renderItem(item) {
      const customLabel = <span class="custom-item">{item.name}</span>;
      return {
        label: customLabel, // for displayed item
        value: item.name, // for title and filter matching
      };
    },
    handleChangeTransfer(targetKeys, direction, moveKeys) {
      this.targetKeys = targetKeys;
    },
    handleAddChangeTransfer(targetKeys, direction, moveKeys) {
      this.targetAddKeys = targetKeys;
      console.log(this.targetAddKeys);
    },
    showModal() {
      this.visibleModal = true;
    },
    showAddModal() {
      this.visibleAddModal = true;
    },
    handleReset() {
      this.types = JSON.parse(this.savedTypes);
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.arabicStyle {
  direction: rtl;
  font-size: 20px;
}

.card >>> .ant-table-tbody tr {
  cursor: pointer !important;
}
</style>
